import { render, staticRenderFns } from "./ShopThemeCustomizer.vue?vue&type=template&id=0b3b1a56&scoped=true&"
import script from "./ShopThemeCustomizer.vue?vue&type=script&lang=js&"
export * from "./ShopThemeCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ShopThemeCustomizer.vue?vue&type=style&index=0&id=0b3b1a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b1a56",
  null
  
)

export default component.exports